import UIDs from "../../../../UIDs";

const uid = UIDs.screens.homework.reviewunit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    REPORT_RESULT: `${uid}.reportResult`,
    NEXT_UNIT_ASYNC: `${uid}.nextUnitAsync`,
    NEXT_UNIT_SUCCESS: `${uid}.nextUnitSuccess`,
    NEXT_UNIT_FAILURE: `${uid}.nextUnitFailure`,
    REVIEW_UNIT_ASYNC: `${uid}.reviewUnitAsync`,
    REVIEW_UNIT_SUCCESS: `${uid}.reviewUnitSuccess`,
    REVIEW_UNIT_FAILURE: `${uid}.reviewUnitFailure`,
    SHOW_FOOTER: `${uid}.showFooter`,
    SHOW_COMMON_MODAL_REF: `${uid}.showCommonModalRef`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
    TOGGLE_ANSWER_ICON: `${uid}.toggleAnswerIcon`,
    CLOSE_ALERT: `${uid}.closeAlert`,
    SET_RECORD_SETTING_FROM_LOCAL: `${uid}.setRecordSettingFromLocal`,
    USER_HOMEWORK_STATUS_CHANGE: `${uid}.homeworkStatusChange`,
    RESTART_UNIT: `${uid}.restartUnit`,
};

export { ActionTypes };
